import * as React from 'react'
import { useMemo } from 'react'

import type { CustomField } from '@sales-center/common'
import { EditableCustomField } from '@user/components/CustomFields'
import type { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import { useHideOptional } from '@user/components/CustomFields/Editable/useHideOptional'

type Props = {
  field: CustomField
  hideOptional?: boolean
  customSettings: ICustomFieldFormSetting[]
}

export function CustomFieldListItem(props: Props) {
  const { field, hideOptional, customSettings } = props

  const fieldSetting = useMemo(
    () => customSettings.find((x) => x.customFieldId === field.id),
    [customSettings, field.id],
  )
  const showField = useHideOptional({ hideOptional, fieldSetting })
  return showField ? (
    <EditableCustomField
      field={field}
      hideOptional={hideOptional}
      fieldSetting={fieldSetting}
    />
  ) : null
}
